export default __webpack_public_path__ + "static/media/smileIcon.e37633c4.svg";